import React, { SyntheticEvent, useCallback } from "react";
import clsx from "clsx";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { FilterColumn } from "types";
import {
	commaAndFloat2Normalizer,
	floatWithComma2Normalizer,
} from "validators";

import styles from "../filter.module.scss";

type FilterColumnProps = {
	column: FilterColumn;
};

const FilterInput = ({ column }: FilterColumnProps) => {
	const { register } = useFormContext();
	const { name, onBlur, onChange, ref } = register(column.name || "");
	const oldText = React.useRef("");

	const runAfterUpdate = useRunAfterUpdate();

	function useRunAfterUpdate() {
		const afterPaintRef = React.useRef(null);
		React.useLayoutEffect(() => {
			if (afterPaintRef.current) {
				//@ts-ignore
				afterPaintRef.current();
				afterPaintRef.current = null;
			}
		});
		return fn => (afterPaintRef.current = fn);
	}

	const onBlurHandler = useCallback(event => {
		event.target.value = floatWithComma2Normalizer(event.target.value);
	}, []);

	return (
		<Form.Control
			name={name}
			ref={ref}
			placeholder={column.placeholder}
			className={clsx(styles.column, styles.input)}
			onChange={(event: any) => {
				const text = event.target;
				const input = event.target.value;
				const result = commaAndFloat2Normalizer(text.value);
				const diff = result.length - oldText.current.length;
				var start;
				if (diff > 0) {
					start = text.selectionStart + diff - 1;
				} else if (diff === 0) {
					start = text.selectionStart + 1;
				} else if (text.selectionStart === 0 && diff === -2) {
					start = text.selectionStart;
				} else {
					start = text.selectionStart + 1 + diff;
				}

				oldText.current = result;
				if (input) {
					event.target.value = result;
				}
				runAfterUpdate(() => {
					text.selectionStart = start;
					text.selectionEnd = start;
				});
				onChange(event);
			}}
			onBlur={(e: SyntheticEvent<any>) => {
				onBlurHandler(e);
				onBlur(e);
			}}
		/>
	);
};

export default FilterInput;
